"use client"

import { useCallback } from "react"
import { ChannelList, ChannelListProps } from "stream-chat-react"
import { MessagingChannelListHeader } from "./MessagesChannelListHeader"
import { ChannelPreview } from "./ChannelPreview"
import { MessagesSidebarPaginator } from "./MessagesSidebarPaginator"
import { useMessages } from "./hooks/useMessages"
import { Spinner, Text } from "@/elements"

type Props = {
  channelListOptions: {
    filters: ChannelListProps["filters"]
    sort: ChannelListProps["sort"]
    options: ChannelListProps["options"]
  }
}

export const LoadingIndicator = () => {
  return (
    <div className="relative flex flex-row justify-center p-4">
      <Spinner className="bg-fg-2" size="medium" />
    </div>
  )
}

export const EmptyState = () => {
  return (
    <div className="p-4 text-center">
      <Text>No channels found</Text>
    </div>
  )
}

export const MessagesSidebar: React.FC<Props> = ({ channelListOptions }) => {
  const { filter, setFilter, setSearchQuery, searchQuery, filters, toggleMobileChannel, setIsCreating } = useMessages()

  const onClickPreview = useCallback(() => {
    setIsCreating(false)
    toggleMobileChannel()
  }, [setIsCreating, toggleMobileChannel])

  const renderChannels = (channels: any, renderChannel: (channel: any) => any) => {
    return channels.map((channel: any, index: number) => {
      const { props } = renderChannel(channel)
      return <ChannelPreview {...props} channel={channel} index={index} onClick={onClickPreview} key={channel.cid} />
    })
  }

  return (
    <div className="w-full border-bg-3 md:border-r">
      <div className="h-[212px]">
        <MessagingChannelListHeader
          filters={filters}
          onClickFilter={setFilter}
          searchQuery={searchQuery}
          onChangeSearch={setSearchQuery}
          activeFilter={filter}
        />
      </div>
      <div className="h-[calc(100dvh-287px)] overflow-auto md:h-[calc(100dvh-212px)]">
        <ChannelList
          {...channelListOptions}
          LoadingIndicator={LoadingIndicator}
          Paginator={MessagesSidebarPaginator as any}
          EmptyStateIndicator={EmptyState}
          renderChannels={renderChannels}
        />
      </div>
    </div>
  )
}
